import React, { useState } from 'react';
import { login } from '../api';
import toast from 'react-hot-toast';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const Login = ({ onLogin }) => {
  const [tokenInput, setTokenInput] = useState('');
  const [showToken, setShowToken] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!tokenInput.trim()) return;

    setLoading(true);
    try {
      const data = await login(tokenInput);
      toast.success('Logged in successfully');
      onLogin(data.user, tokenInput);
    } catch (err) {
      toast.error(err.message || 'Invalid token or login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>THE Queue Sniper</h1>
        <p>Enter your Discord token to continue</p>
        <form onSubmit={handleSubmit}>
          <div className="password-wrapper">
            <input
              type={showToken ? 'text' : 'password'}
              className="input-field"
              placeholder="Discord Token"
              value={tokenInput}
              onChange={(e) => setTokenInput(e.target.value)}
              disabled={loading}
              required
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowToken(!showToken)}
              tabIndex="-1"
            >
              {showToken ? <FiEyeOff size={18} /> : <FiEye size={18} />}
            </button>
          </div>
          <button type="submit" className="btn btn-blurple" style={{ width: '100%', padding: '11px 16px', fontSize: '14px' }} disabled={loading}>
            {loading ? 'Authenticating...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
